export class BookingsFiltersPath {
  public static readonly SERVICE =
    'expeditionStop.expedition.serviceAvailability.service.serviceInfo.id';
  public static readonly USER = 'user.id';
  public static readonly DRIVER = 'expeditionStop.expedition.driver.id';
  public static readonly VEHICLE = 'expeditionStop.expedition.vehicle.id';
  public static readonly INITIAL_STOP = 'expeditionStop.id';
  public static readonly EXIT_STOP = 'seats.exitExpeditionStop.id';
  public static readonly DATE_TIME = '';
}
